// D8-4 (owner rulings R-17, A-08, 2026-10-12/17): the per-tenant gift-card ISSUANCE switch.
//
// Issuance stays OFF by default for every tenant. Only a platform operator turns it on, once the
// tenant's program is covered by cashout/records rules (D14) and the expert review approved it. The
// plan's module grant (`gift-cards` entitlement) alone never turns it on, and a tenant admin cannot:
// the switch is a numeric key on the `gift-cards` entitlement's `limits` jsonb, written only through
// the audited operator route (modules/tenants/server/admin-entitlements-routes.ts, `POST /apply`).
// `getEntitlementLimit` reads an absent key (or any non-positive value) as null, which means OFF, so
// "default off" needs no row, no migration and no seed.
//
// Operator activation (owner decision, 2026-10-19): the operator's deliberate grant of full
// gift-card access includes issuance in that same audited action; no separate UI switch is required.
// This is the operator's issuance decision, subject to the program clearance above. Subscription
// tier grants alone still leave issuance off. An already-full row whose issuance is off requires an
// explicit activation carrying the limits key; an ordinary same-mode save or expiry edit preserves it.
//
// Lifecycle (owner ruling on O-D8-6, 2026-10-17): the key is a saved PREFERENCE on the tenant's existing
// entitlement, not an entitlement of its own. Actual issuance needs the preference AND an active, writable
// `gift-cards` entitlement (apps/root-api wires exactly that). A limits-only write never creates an entitlement;
// a deliberate new operator full grant creates the override and enables issuance together. A preference write
// never changes who owns an existing row, so a subscription-backed row stays `plan`: cancelling it makes it read-only
// (issuance stops, existing cards stay redeemable), it goes inactive when the post-cancel window ends, and a
// resubscribe restores access with the preference intact (the plan applier carries the key over). If a tier stops
// listing gift-cards the row is revoked and the preference goes with it.
//
// Shared by modules/tenants (apply-route validation), modules/gift-cards (enforcement at every issue
// entry point) and apps/root-api (the reader wiring).
/** The `limits` key on the `gift-cards` entitlement. `1` = issuance enabled; absent = disabled. */
export const GIFT_CARD_ISSUANCE_ENABLED_LIMIT_KEY = 'gift_card_issuance_enabled';
/** The only value that turns issuance on. There is no "unlimited" and no other meaning. */
export const GIFT_CARD_ISSUANCE_ENABLED_VALUE = 1;
/**
 * Problems with a proposed `limits` object for module `gift-cards`; [] means valid. Only the issuance
 * key is validated (it must be exactly 1: turning issuance OFF is deleting the key, not writing 0, so
 * the stored state has one on-representation). Other keys keep the generic nonnegative-integer rule
 * of the apply route.
 */
export function validateGiftCardsLimits(limits) {
    const problems = [];
    if (GIFT_CARD_ISSUANCE_ENABLED_LIMIT_KEY in limits) {
        const v = limits[GIFT_CARD_ISSUANCE_ENABLED_LIMIT_KEY];
        if (v !== GIFT_CARD_ISSUANCE_ENABLED_VALUE) {
            problems.push(`${GIFT_CARD_ISSUANCE_ENABLED_LIMIT_KEY} must be ${GIFT_CARD_ISSUANCE_ENABLED_VALUE} to enable issuance; remove the key to disable it`);
        }
    }
    return problems;
}
//# sourceMappingURL=issuance-switch.js.map